import { ActionBase } from '../../../core/store/action/ActionBase';
import { LookupModel } from '../../../common/models/LookupModel';

export const GET_USER_SUBMITTING_ENTITIES_SUCCESS = '[Customer] Get User Submitting Entities Success';

export class GetUserSubmittingEntitiesSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_USER_SUBMITTING_ENTITIES_SUCCESS;

  constructor(public payload: { userKey: string, submittingEntities: LookupModel[] }) { }
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/GetUserSubmittingEntitiesSuccessAction.ts